import * as React from 'react';
import { Layout } from 'antd';
import injectSheet from 'react-jss';
import * as numeral from 'numeral';

const styles = theme => ({
  whiteBackground: {
    background: '#fff',
    padding: 0,
  },
  header: {
    background: '#fff',
    padding: 0,
  },
  number: {
    fontSize: '30px',
    fontWeight: 500,
    background: '#fff',
    textAlign: 'center',
  },
  countLabel: {
    background: '#fff',
    textAlign: 'center',
    opacity: 0.7,
    fontSize: '13px',
  },
});
class NumberViz extends React.PureComponent<any, any> {

  render() {
    const { chartData, classes, theme }: any = this.props;
    const { Header, Footer,  Content } = Layout;
    return (<div>
      <Layout className={classes.whiteBackground}>
        {/* <Header className={classes.header}>{chartData.header}</Header> */}
        <Content className={classes.number}
          style={{ color: (
            chartData.header
          && chartData.header.count
          && Number(chartData.header.count.title.toString()) < 0) ?
            theme.errorColor : '#262626' }}
        >{(chartData.header
          && chartData.header.count
          && chartData.header.count.title) ?
          numeral(Number(chartData.header.count.title.toString()))
            .format('(0,0 a)').toUpperCase() : '-'}</Content>
        <Footer className={classes.countLabel}>Total Count</Footer>
      </Layout>
    </div>);
  }
}
export default injectSheet(styles)(NumberViz);
